<template>
    <div class="renewal-pending-manage">
        <Paper class="renewal-pending-manage-paper">
            <list-layout-paper>
                <template slot="header-search">
                    <div class="header-search-title">
                        <div class="title-text">续签待办完成情况</div>
                        <div class="title-tips">查看续签待办事项的完成状态、进度及明细数据
                            <el-tooltip effect="dark" :content="tableConfig.titleTips" placement="top">
                                <img class="icon-pic" v-if="tableConfig.titleTips"
                                    src="@/assets/images/icon-question.png" />
                            </el-tooltip>
                        </div>
                    </div>
                    <search-box ref="searchBox" :search-key="tableConfig.name" :fields="tableConfig.searchFields"
                        :showResetBtn="true" @search-change="renewalPendingList.searchList"
                        />
                </template>
                <template slot="header-button">
                    <lotsButton type="primary" size="mini" title="导出" @click="exportFile" v-has="authorityCode.export"
                        icon="el-icon-download">
                        <span class="icon iconfont">导出</span>
                    </lotsButton>
                </template>
                <!-- 表格 -->
                <template v-slot:list="{ tableHeight }">
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane label="行业" name="industry"></el-tab-pane>
                        <el-tab-pane label="分公司" name="company"></el-tab-pane>
                        <el-tab-pane label="个人" name="personal"></el-tab-pane>
                    </el-tabs>
                    <table-box class="prescreen" v-loading="renewalPendingList.tableLoading" :selection="tableConfig.selection"
                        :control="false" :columns="tableConfig[activeName+'Columns']" :height="tableConfig.height"
                        :tableData="renewalPendingList.totalData" :actions="tableConfig.actioWns" :editDisableRule="() => false"
                        :allowRowClick="false" :rows="renewalPendingList.totalData" @sort-change="handleSort">
                        <template #col-header="{ col }">
                            <span v-if="col.prop === 'riskAssessmentIncomplete'">
                                {{ col.label }}
                                <el-tooltip effect="dark" placement="top">
                                    <i class="el-icon-question"></i>
                                    <template slot="content">
                                        针对续签登记待办，若「续签风险」「续签状态」「风险原因」三个关键字段中，任意一个字段为空值，即判定为该状态<br/>
                                    </template>
                                </el-tooltip>
                            </span>
                            <span v-else-if="col.prop === 'finalResultUnconfirmed'">
                                {{ col.label }}
                                <el-tooltip effect="dark" placement="top">
                                    <i class="el-icon-question"></i>
                                    <template slot="content">
                                        续签状态不属于「已续签」「已终止」，且该待办的跟进月份为当前月份<br/>
                                    </template>
                                </el-tooltip>
                            </span>
                            <span v-else-if="col.prop === 'completed'">
                                {{ col.label }}
                                <el-tooltip effect="dark" placement="top">
                                    <i class="el-icon-question"></i>
                                    <template slot="content">
                                        排除上述两种状态的所有续签登记待办，即风险预判字段齐全、且续签状态为明确结果（已续签/已终止）待办，以及续签状态不属于「已续签」「已终止」，且该待办的跟进月份不是当前月份的待办<br/>
                                    </template>
                                </el-tooltip>
                            </span>
                            <span v-else>{{ col.label }}</span>
                        </template>
                        <template #col-append="{col, row}">
                            <span @click="openDetailDialog(row,col.prop)" class="click-text"
                            v-if="['riskAssessmentIncomplete','finalResultUnconfirmed','completed','totalTodos','editedTaskCount','totalTaskCount'].includes(col.prop)">
                                {{ row[col.prop] }}</span>
                                <span v-if="col.prop === 'incompleteTotal'">{{ row.riskAssessmentIncomplete + row.finalResultUnconfirmed }}</span>
                        </template>
                    </table-box>
                </template>
                <template slot="footer">
                    <lots-pagination @size-change="renewalPendingList.sizeChange"
                        :current-page.sync="renewalPendingList.pageNo" @current-change="renewalPendingList.pageChange"
                        size="small" layout="total, sizes, prev, pager, next, jumper"
                        :total="renewalPendingList.pageTotal" />
                </template>
            </list-layout-paper>
            <div v-if="!renewalPendingList.tableLoading && renewalPendingList.pageTotal > 0">
                <template v-if="activeName === 'industry'">
                    <div class="list-summary-title">续签待办总结</div>
                    <div class="list-summary-text" v-for="(item,i) in renewalPendingList.totalData" :key="i">
                        <span v-if="item.industryCategoriesCode">
                            {{item.industryCategoriesName}}行业还有{{item.riskAssessmentIncomplete + item.finalResultUnconfirmed}}任务未完成，
                            风险预判未完成（M+3）{{ item.riskAssessmentIncomplete }}条，
                            未完成率{{ (item.riskAssessmentIncomplete/item.totalTodos*100).toFixed(1) + '%' }}；
                            最终结果未确认（当月）{{ item.finalResultUnconfirmed }}条，未完成率{{((item.finalResultUnconfirmed/item.totalTodos)*100).toFixed(1) + '%'}}；
                        </span>
                    </div>
                </template>
                <template v-if="activeName === 'company'">
                    <div class="list-summary-title">续签待办总结</div>
                    <div class="list-summary-text" v-for="(item,i) in renewalPendingList.totalData" :key="i">
                        <span v-if="item.companyCode">
                            {{item.companyName}}公司还有{{item.riskAssessmentIncomplete + item.finalResultUnconfirmed}}任务未完成，
                            风险预判未完成（M+3）{{ item.riskAssessmentIncomplete }}条，
                            未完成率{{ (item.riskAssessmentIncomplete/item.totalTodos*100).toFixed(1) + '%' }}；
                            最终结果未确认（当月）{{ item.finalResultUnconfirmed }}条，未完成率{{((item.finalResultUnconfirmed/item.totalTodos)*100).toFixed(1) + '%'}}；
                        </span>
                    </div>
                </template>
                <template v-if="activeName === 'personal'">
                    <div class="list-summary-title">续签待办总结</div>
                    <div class="list-summary-text">
                        <div v-for="(item,i) in personalList.industry" :key="item.department+i" class="list-summary-text-item">
                            <span>{{item.department}}行业：</span>
                            <template v-if="item.children && item.children.length>0">
                                <span v-for="obj in item.children" :key="obj.handlerCode">
                                    {{obj.handlerName}}还有{{obj.totalTaskCount-obj.completed}}任务未完成，
                                    风险预判未完成（M+3）{{obj.riskAssessmentIncomplete}}条，
                                    未完成率{{ (obj.riskAssessmentIncomplete/obj.totalTaskCount*100).toFixed(1) + '%' }}；
                                    最终结果未确认（当月）{{obj.finalResultUnconfirmed}}条，
                                    未完成率{{ (obj.finalResultUnconfirmed/obj.totalTaskCount*100).toFixed(1) + '%' }}；
                                </span>
                            </template>
                        </div>
                        <div v-for="(item,i) in personalList.company" :key="item.companyName+i" class="list-summary-text-item">
                            <span>{{item.companyName}}：</span>
                            <template v-if="item.children && item.children.length>0">
                                <span v-for="obj in item.children" :key="obj.handlerCode">
                                    {{obj.handlerName}}还有{{obj.totalTaskCount-obj.completed}}任务未完成，
                                    风险预判未完成（M+3）{{obj.riskAssessmentIncomplete}}条，
                                    未完成率{{ (obj.riskAssessmentIncomplete/obj.totalTaskCount*100).toFixed(1) + '%' }}；
                                    最终结果未确认（当月）{{obj.finalResultUnconfirmed}}条，
                                    未完成率{{ (obj.finalResultUnconfirmed/obj.totalTaskCount*100).toFixed(1) + '%' }}；
                                </span>
                            </template>
                        </div>
                        <div v-for="(item) in personalList.personal" :key="item.handlerCode" class="list-summary-text-item">
                            <span>
                                {{item.handlerName}}还有{{item.totalTaskCount-item.completed}}任务未完成，
                                风险预判未完成（M+3）{{item.riskAssessmentIncomplete}}条，
                                未完成率{{ (item.riskAssessmentIncomplete/item.totalTaskCount*100).toFixed(1) + '%' }}；
                                最终结果未确认（当月）{{item.finalResultUnconfirmed}}条，
                                未完成率{{ (item.finalResultUnconfirmed/item.totalTaskCount*100).toFixed(1) + '%' }}；
                            </span>
                        </div>
                    </div>
                </template>
            </div>
        </Paper>
        <listDialog ref="listDialogRef" />
    </div>
</template>

<script>
import btnAuthority from '@/modules/mdm/btnAuthority.js';
import { ref, reactive, onMounted } from '@vue/composition-api';
import Paper from '@/components/core/Paper';
import listLayoutPaper from '@/components/lots/listLayout/Paper';
import lotsPagination from '@/components/lots/lotsPagination/Index';
import searchBox from '@/components/lots/searchBox';
import lotsButton from '@/components/lots/lotsButton';
import tableBox from '@/components/lots/tableBox/Index';
import { config } from './config.js';
import _ from 'lodash';
import { AdvanceListClass } from '@/modules/mdm/composition/dc/common/list/AdvanceListClass';
import utils from '@/components/utils/common.js';
import { getDictDataApi } from '@mdm/api/contractManage/contractListApi.js';
import {
    getContractRenewalStatisticsByCompany,
    getContractRenewalStatisticsByIndustry,
    getContractRenewalStatisticsByUser,
    exportContractRenewalStatistics
} from '@mdm/api/pendingManage/renewalPending.js';
import otherUtils from '@/modules/mdm/utils/otherCommonFunc.js';
import listDialog from './components/listDialog/Index';
import { getIndustryTree } from '@mdm/api/contractManage/contractRegistration.js';
import { Message } from 'element-ui';

export default {
    name: 'renewalPending',
    components: {
        lotsPagination,
        tableBox,
        Paper,
        listLayoutPaper,
        searchBox,
        lotsButton,
        listDialog
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const authorityCode = reactive(btnAuthority.renewalPending);
        const tableConfig = reactive(_.cloneDeep(config));
        const activeName = ref('industry');
        const personalList = ref({
            industry: [], // 行业分类
            personal: [], // 既没有分公司也没有行业
            company: []// 分公司
        });
        // 用于去重的 Map
        const industryMap = new Map();
        const personalMap = new Map();
        const companyMap = new Map();
        class OverseasListClass extends AdvanceListClass {
            beforeGetList(condition) {
                return searchDataFormat(condition);
            };
            afterGetList(res) {
                if (res && +res.code === 0) {
                    renewalPendingList.pageTotal.value = res.data.totalCount;
                    renewalPendingList.totalData.value = res.data.list || [];
                    // 如果是 personal tab，需要重置数据，避免分页切换时重复累积
                    if (activeName.value === 'personal') {
                        // 清空 Map 和 personalList，重新开始累积当前页数据
                        industryMap.clear();
                        companyMap.clear();
                        personalMap.clear();
                        personalList.value = {
                            industry: [],
                            personal: [],
                            company: []
                        };
                    }
                    const { industry = [], personal = [], company = [] } = personalList.value;
                    if (activeName.value === 'personal' && res.data.list && res.data.list.length > 0) {
                        const { list = [] } = res.data;
                        list.forEach(item => {
                            const { companyName, department, handlerCode } = item;
                            // 处理 industry 分类（唯一行业名称）
                            if (department) {
                                if (!industryMap.has(department)) {
                                    industryMap.set(department, true);
                                    industry.push({ department, children: [item] });
                                } else {
                                    const index = industry.findIndex(it => it.department === department);
                                    if (index > -1) {
                                        industry[index].children.push(item);
                                    }
                                }
                            }
                            // 处理 companyName 分类（唯一分公司名称）
                            if (companyName) {
                                if (!companyMap.has(companyName)) {
                                    companyMap.set(companyName, true);
                                    company.push({ companyName, children: [item] });
                                } else {
                                    const index = company.findIndex(it => it.companyName === companyName);
                                    if (index > -1) {
                                        company[index].children.push(item);
                                    }
                                }
                            }
                            // 处理 personal 分类（无名称）
                            if (!companyName && !department) {
                                if (!personalMap.has(handlerCode)) {
                                    personalMap.set(handlerCode, true);
                                    personal.push(item);
                                }
                            }
                        });
                    }
                    personalList.value = {
                        industry,
                        company,
                        personal
                    };
                }
            };
        }
        const renewalPendingList = new OverseasListClass({
            Api: {
                listApi: getContractRenewalStatisticsByIndustry
            }
        });
        // eslint-disable-next-line complexity
        const searchDataFormat = (condition = {}, params = {}) => {
            condition.orderBy = orderBy.value;
            condition.orderByType = orderByType.value;
            if (condition.companyCodes) {
                // 选择分公司
                condition.companyCodeList = condition.companyCodes.split(',');
                Reflect.deleteProperty(condition, 'companyCodes');
                Reflect.deleteProperty(condition, 'companyNames');
            }
            if (condition.renewalContractorMips) {
                // 选择续签承接人
                condition.handlerCodeList = condition.renewalContractorMips.split(',');
                Reflect.deleteProperty(condition, 'renewalContractorMips');
                Reflect.deleteProperty(condition, 'renewalContractors');
            }
            if (condition.followupExpiryDate) {
                // 跟进终止日期
                condition.startFollowupDate = utils.formatDateTime(condition.followupExpiryDate[0]);
                condition.endFollowupDate = utils.formatDateTime(condition.followupExpiryDate[1]);
                Reflect.deleteProperty(condition, 'followupExpiryDate');
            }
            Object.keys(condition).forEach(v => {
                !condition[v] && condition[v] !== 0 && (condition[v] = undefined);
            });
            return { ...condition, ...params };
        };
        const orderBy = ref('');
        const orderByType = ref('');
        const orderType = {
            ascending: 'asc',
            descending: 'desc'
        };
        // 排序
        const handleSort = ({ prop, order }) => {
            // 统计字段，非库字段，直接用驼峰
            orderBy.value = prop;
            orderByType.value = orderType[order];
            if (!order) {
                orderBy.value = '';
                orderByType.value = '';
            }
            renewalPendingList.getList();
        };
        const industryData = ref([]);
        const getIndustryTreeList = () => {
            return getIndustryTree({
                industryStatus: 1 // 0-停用、1-启用
            }).then(res => {
                if (res && +res.code === 0) {
                    industryData.value = res.data;
                }
            });
        };
        // 工具函数：转excelTitle对象
        const toExcelTitle = (item) => ({
            name: item.name,
            property: item.property
        });
        const exportFile = async() => {
            // 导出
            await setupContext.refs.searchBox.submitSearch(); // 解决输入参数不生效问题
            const { value } = renewalPendingList.searchModel;
            const newData = searchDataFormat(_.cloneDeep(value)); // 解决搜索参数被清空的问题
            const excelFileList = otherUtils.sortColumnsByFixed(tableConfig[activeName.value + 'Columns'])?.filter(it => it.property !== 'file');
            // 最新格式化导出
            const excelTitleList = excelFileList?.map(toExcelTitle);
            let exportType = null;
            switch (activeName.value) {
            case 'company':
                exportType = 1;
                break;
            case 'personal':
                exportType = 3;
                break;

            default:
                exportType = 2;
                break;
            }

            const params = {
                ...newData,
                excelTitleList,
                exportType
            };
            Object.keys(params).forEach(v => {
                if (params[v] === undefined || params[v] === null || params[v] === '') {
                    delete params[v];
                }
            });
            exportContractRenewalStatistics(params).then(res => {
                if (+res.code === 0) {
                    Message.success('已发送导出请求,请稍后到右上角用户文件列表中下载');
                }
            }).finally(() => { });
        };
        const handleClick = () => {
            if (activeName.value === 'industry') {
                renewalPendingList.listApi = getContractRenewalStatisticsByIndustry;
            } else if (activeName.value === 'company') {
                renewalPendingList.listApi = getContractRenewalStatisticsByCompany;
            } else if (activeName.value === 'personal') {
                renewalPendingList.listApi = getContractRenewalStatisticsByUser;
                // 切换 tab 时清空 personalList 和 Map，避免数据累积
                industryMap.clear();
                companyMap.clear();
                personalMap.clear();
                personalList.value = {
                    industry: [],
                    personal: [],
                    company: []
                };
            }
            renewalPendingList.pageNo.value = 1;
            renewalPendingList.getList();
        };
        const openDetailDialog = (row, prop) => {
            if (row[prop] < 1) {
                return;
            }
            const paramsData = searchDataFormat(_.cloneDeep(renewalPendingList.searchModel.value));
            switch (prop) {
            // 统计类型：0-全部(totalTaskCount)，1-风险预判未完成，2-最终结果未确认，3-已完成，4-已编辑任务(editedTaskCount)
            case 'totalTaskCount':
                paramsData.statisticsType = 0;
                break;
            case 'riskAssessmentIncomplete':
                paramsData.statisticsType = 1;
                break;
            case 'finalResultUnconfirmed':
                paramsData.statisticsType = 2;
                break;
            case 'completed':
                paramsData.statisticsType = 3;
                break;
            case 'editedTaskCount':
                paramsData.statisticsType = 4;
                break;
            default:
                break;
            }
            Reflect.deleteProperty(paramsData, 'orderBy');
            Reflect.deleteProperty(paramsData, 'orderByType');
            setupContext.refs.listDialogRef.openDialog(activeName.value, row, paramsData);
        };
        const dictData = ref({});
        onMounted(async() => {
            const res = await getDictDataApi({
                dictCodes: `NEOCRM_CUSTOMER_LEVEL,CRM_CONTRACT_RENEWAL_STATUS,SYS_CR_CONTRACT_STATUS,SYS_WM_CONTRACT_CHARACTER,CRM_CONTRACT_RENEWAL_RISK`
            });
            dictData.value = res.data;
            await getIndustryTreeList();
            tableConfig.searchFields.forEach(it => {
                if (it.value === 'industryCategoriesCodeList') {
                    // it.options = industryData.value;
                    const options = industryData.value.map(arr => ({
                        value: arr.industryCode,
                        label: arr.industryName
                    }));
                    it.options = options;
                }
                if (it.value === 'customerLevelCodeList') {
                    const options = Object.entries(dictData.value.NEOCRM_CUSTOMER_LEVEL).map(arr => ({
                        value: arr[0],
                        label: arr[1]
                    }));
                    it.options = options;
                }
                if (it.value === 'renewalStatusList') {
                    const options = Object.entries(dictData.value.CRM_CONTRACT_RENEWAL_STATUS).map(arr => ({
                        value: arr[0],
                        label: arr[1]
                    }));
                    options.push({ value: '0', label: '空' }); // 添加空
                    it.options = options;
                }
                if (it.value === 'renewalRiskList') {
                    const options = Object.entries(dictData.value.CRM_CONTRACT_RENEWAL_RISK).map(arr => ({
                        value: arr[0],
                        label: arr[1]
                    }));
                    options.push({ value: '4', label: '空' }); // 添加空
                    it.options = options;
                }
            });
            const queryParams = {
                // effectTime: utils.defaultDate('365')
            };
            setupContext.refs.searchBox.setQueryParams(queryParams);
            setupContext.refs.searchBox.submitSearch();
        });
        return {
            authorityCode,
            renewalPendingList,
            personalList,
            tableConfig,
            exportFile,
            activeName,
            handleClick,
            openDetailDialog,
            handleSort
        };
    }
};

</script>

<style lang="less">
.renewal-pending-manage {
  .header-search-title {
    margin-bottom: 20px;
    .title-text {
      font-weight: bolder;
      font-size: 20px;
      margin-bottom: 10px;
    }
    .title-tips {
      color: #888;
      display: flex;
      align-content: center;
      .icon-pic {
        width: 14px;
        height: 14px;
        margin-left: 4px;
      }
    }
  }
  .header-button {
    margin-top: 67px;
  }
  .list-layout .list-header .el-input {
    margin-left: 0;
  }
  .list-summary-title {
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 10px;
  }
  .list-summary-text {
    span {
      color: #333;
      font-size: 14px;
      margin-bottom: 5px;
      line-height: 24px;
    }
    // .list-summary-text-item{
    //     line-height: 24px;
    // }
  }
  .click-text {
    color: #4285f5;
    cursor: pointer;
  }
}
</style>
